import React from "react";

// reactstrap components
import {
  Button,
  NavItem,
  NavLink,
  Nav,
  TabContent,
  TabPane,
  Container,
  Row,
  Col,
  UncontrolledTooltip
} from "reactstrap";

// core components
import ExamplesNavbar from "components/Navbars/ExamplesNavbar.js";
import ProfilePageHeader from "components/Headers/ProfilePageHeader.js";
import DefaultFooter from "components/Footers/DefaultFooter.js";

function ProfilePage(props) {
  const [pills, setPills] = React.useState("2");
  React.useEffect(() => {
    document.body.classList.add("profile-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    return function cleanup() {
      document.body.classList.remove("profile-page");
      document.body.classList.remove("sidebar-collapse");
    };
  });
  return (
    <>
      <ExamplesNavbar onChange={props.onChange} productselected={props.productselected} products={props.products} user={props.user} userstatus={props.userstatus} admin={props.admin}  />
      <div className="wrapper">
        <ProfilePageHeader user={props.user} />
        <div className="section">
          <Container>
          <Row>
              <Col className="ml-auto mr-auto text-center" md="8">
                <h2 className="title">Mi información</h2>
                <h3 >
                {props.user.mail}
                </h3>
                <h3 >
                {props.user.emp}
                </h3>
                <h3 >
                {props.user.status}
                </h3>
              </Col>
            </Row>
          </Container>
        </div>
        <DefaultFooter />
      </div>
    </>
  );
}

export default ProfilePage;